if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          if (performance.now() >= (this.dfSwipeClickUntil || 0)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
        let gesture = null;
        const blockedSwipeTarget = (target) => target.closest('button, input, select, textarea, a, [contenteditable="true"], .df-video-controls, product-model');
        this.addEventListener('touchstart', (event) => {
          gesture = null;
          if (!this.hasAttribute('open') || !this.classList.contains('df-fit-viewer') ||
              !window.matchMedia('(max-width: 749px)').matches || event.touches.length !== 1 ||
              blockedSwipeTarget(event.target) || !event.target.closest('.product-media-modal__content')) return;
          const touch = event.touches[0];
          gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, horizontal: false, vertical: false };
        }, { passive: true, capture: true });
        this.addEventListener('touchmove', (event) => {
          if (!gesture) return;
          if (event.touches.length !== 1) { gesture = null; return; }
          const touch = Array.from(event.touches).find((item) => item.identifier === gesture.id);
          if (!touch) return;
          const dx = Math.abs(touch.clientX - gesture.x);
          const dy = Math.abs(touch.clientY - gesture.y);
          if (!gesture.horizontal && !gesture.vertical && Math.max(dx, dy) > 12) {
            gesture.horizontal = dx > dy * 1.3;
            gesture.vertical = !gesture.horizontal;
          }
          if (gesture.horizontal) {
            this.dfSwipeClickUntil = performance.now() + 700;
            if (event.cancelable) event.preventDefault();
          }
        }, { passive: false, capture: true });
        this.addEventListener('touchend', (event) => {
          const current = gesture;
          gesture = null;
          if (!current || !current.horizontal || event.touches.length) return;
          const touch = Array.from(event.changedTouches).find((item) => item.identifier === current.id);
          if (!touch) return;
          this.dfSwipeClickUntil = performance.now() + 700;
          if (event.cancelable) event.preventDefault();
          const dx = touch.clientX - current.x;
          const dy = Math.abs(touch.clientY - current.y);
          if (Math.abs(dx) >= 48 && Math.abs(dx) > dy * 1.3) this.changeFitImage(dx < 0 ? 1 : -1, event.isTrusted);
        }, { passive: false, capture: true });
        this.addEventListener('touchcancel', () => { gesture = null; }, { passive: true, capture: true });
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open') || event.defaultPrevented || event.isComposing || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.composedPath().some((node) => node instanceof Element && node.matches('input, textarea, select, button, a[href], summary, [contenteditable]:not([contenteditable="false"]), [role="button"], [role="slider"], [role="textbox"], video[controls], audio[controls], .df-video-controls'))) return;
          if (event.key === ' ' || event.code === 'Space') {
            const video = this.querySelector('deferred-media.active video[data-df-player-ready]');
            if (!video) return;
            event.preventDefault();
            event.stopPropagation();
            if (event.repeat) return;
            if (video.paused || video.ended) {
              if (video.ended) video.currentTime = 0;
              video.muted = false;
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            if (!this.classList.contains('df-fit-viewer') || this.getFitMedia().length < 2) return;
            event.preventDefault();
            event.stopPropagation();
            this.changeFitImage(event.key === 'ArrowLeft' ? -1 : 1, event.isTrusted);
          }
        });
        this.addEventListener('click', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.target.closest('button, input, .df-video-controls')) return;
          const video = this.querySelector('deferred-media.active video[data-df-player-ready]');
          if (!video) return;
          const bounds = video.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right ||
              event.clientY < bounds.top || event.clientY > bounds.bottom) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (video.paused) {
            if (video.ended) video.currentTime = 0;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }, true);
        this.querySelectorAll('[data-df-fit-step]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.changeFitImage(Number(button.dataset.dfFitStep), event.isTrusted);
          });
        });
        this.addEventListener('click', (event) => {
          if (this.classList.contains('df-fit-viewer') && !event.target.closest('button, deferred-media, product-model, .product-media-modal__model')) this.hide();
        });
      }

      setupVideo(video) {
        if (video.dataset.dfPlayerReady) return;
        video.dataset.dfPlayerReady = 'true';
        video.controls = false;
        video.loop = false;
        video.playsInline = true;
        video.volume = 0.5;
        const host = video.parentElement;
        host.querySelector('.deferred-media__poster')?.remove();
        const labels = host.dataset;
        const makeButton = (label, text) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', label);
          button.textContent = text;
          return button;
        };
        const replay = makeButton(labels.dfPlayLabel, '▶');
        replay.className = 'df-video-replay';
        replay.hidden = true;
        host.appendChild(replay);
        const controls = document.createElement('div');
        controls.className = 'df-video-controls';
        const toggle = makeButton(labels.dfPauseLabel, 'Ⅱ');
        const seek = document.createElement('input');
        seek.type = 'range';
        seek.min = '0';
        seek.max = '0';
        seek.step = '0.1';
        seek.value = '0';
        seek.disabled = true;
        seek.className = 'df-video-seek';
        seek.setAttribute('aria-label', labels.dfSeekLabel);
        const time = document.createElement('span');
        time.className = 'df-video-time';
        const mute = makeButton(labels.dfMuteLabel, '♪');
        const volume = document.createElement('input');
        volume.type = 'range';
        volume.min = '0';
        volume.max = '1';
        volume.step = '0.05';
        volume.value = '0.5';
        volume.className = 'df-video-volume';
        volume.setAttribute('aria-label', labels.dfVolumeLabel);
        controls.append(toggle, seek, time, mute, volume);
        host.appendChild(controls);
        ['click', 'pointerdown', 'pointerup', 'keydown', 'keyup'].forEach((type) => {
          controls.addEventListener(type, (event) => {
            if (type === 'keyup' && event.key === 'Escape') return;
            event.stopPropagation();
          });
        });
        let scrubbing = false;
        let resumeAfterSeek = false;
        let bottomHovered = false;
        let touchUntil = 0;
        let interacting = false;
        let keyboardFocus = false;
        let hideTimer;
        const updateControls = () => {
          const visible = video.paused || video.ended || scrubbing || interacting ||
            bottomHovered || keyboardFocus || performance.now() < touchUntil;
          host.classList.toggle('df-controls-visible', visible);
        };
        const revealTouch = () => {
          touchUntil = performance.now() + 3500;
          clearTimeout(hideTimer);
          hideTimer = setTimeout(updateControls, 3550);
          updateControls();
        };
        host.addEventListener('pointermove', (event) => {
          if (event.pointerType !== 'mouse') return;
          const bounds = host.getBoundingClientRect();
          bottomHovered = event.clientY >= bounds.bottom - 72;
          updateControls();
        });
        host.addEventListener('pointerleave', () => {
          bottomHovered = false;
          updateControls();
        });
        host.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') revealTouch();
        });
        controls.addEventListener('pointerdown', (event) => {
          interacting = true;
          if (event.pointerType !== 'mouse') revealTouch();
          updateControls();
        });
        const releaseControls = () => {
          interacting = false;
          if (performance.now() < touchUntil) revealTouch();
          updateControls();
        };
        document.addEventListener('pointerup', releaseControls);
        document.addEventListener('pointercancel', releaseControls);
        controls.addEventListener('keydown', () => {
          keyboardFocus = true;
          updateControls();
        });
        controls.addEventListener('focusout', () => {
          keyboardFocus = false;
          updateControls();
        });
        const format = (seconds) => {
          const value = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
          return Math.floor(value / 60) + ':' + String(value % 60).padStart(2, '0');
        };
        const update = () => {
          const valid = Number.isFinite(video.duration) && video.duration > 0;
          seek.disabled = !valid;
          seek.max = valid ? String(video.duration) : '0';
          if (!scrubbing) seek.value = String(video.currentTime || 0);
          time.textContent = format(video.currentTime) + ' / ' + format(video.duration);
          toggle.textContent = video.paused ? '▶' : 'Ⅱ';
          toggle.setAttribute('aria-label', video.paused ? labels.dfPlayLabel : labels.dfPauseLabel);
          replay.hidden = !video.paused || scrubbing;
          updateControls();
        };
        const play = () => {
          if (video.ended) video.currentTime = 0;
          video.play().catch(update);
        };
        toggle.addEventListener('click', () => { video.paused ? play() : video.pause(); });

        replay.addEventListener('pointerup', (event) => event.stopPropagation());
        replay.addEventListener('click', (event) => {
          event.stopPropagation();
          play();
        });
        seek.addEventListener('input', () => {
          if (seek.disabled) return;
          if (!scrubbing) {
            resumeAfterSeek = !video.paused;
            scrubbing = true;
            video.pause();
          }
          video.currentTime = Math.min(video.duration, Math.max(0, Number(seek.value)));
          time.textContent = format(video.currentTime) + ' / ' + format(video.duration);
        });
        const finishSeek = () => {
          if (!scrubbing) return;
          scrubbing = false;
          if (resumeAfterSeek && video.currentTime < video.duration) play();
          resumeAfterSeek = false;
          update();
        };
        seek.addEventListener('change', finishSeek);
        seek.addEventListener('pointercancel', finishSeek);
        const updateVolume = () => {
          volume.value = String(video.muted ? 0 : video.volume);
          mute.textContent = video.muted || video.volume === 0 ? '×' : '♪';
          mute.setAttribute('aria-label', video.muted ? labels.dfUnmuteLabel : labels.dfMuteLabel);
        };
        mute.addEventListener('click', () => { video.muted = !video.muted; updateVolume(); });
        volume.addEventListener('input', () => {
          video.volume = Number(volume.value);
          video.muted = video.volume === 0;
          updateVolume();
        });
        video.addEventListener('volumechange', updateVolume);
        ['loadedmetadata', 'durationchange', 'timeupdate', 'play', 'pause', 'ended', 'seeked'].forEach((event) => video.addEventListener(event, update));
        updateVolume();
        update();
      }

      getFitMedia() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]')).filter((item) =>
          item.tagName === 'IMG' ||
          (item.tagName === 'DEFERRED-MEDIA' &&
            (item.querySelector('video') || item.querySelector('template')?.content.querySelector('video')))
        );
      }

      updateFitArrows() {
        const items = this.getFitMedia();
        const enabled = items.length > 1 && items.some((item) => item.classList.contains('active'));
        this.querySelectorAll('[data-df-fit-step]').forEach((button) => { button.hidden = !enabled; });
      }

      activateFitMedia(next, userInitiated = false) {
        window.pauseAllMedia();
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((item) => {
          item.classList.toggle('active', item === next);
        });
        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = 0;
        if (next.tagName === 'DEFERRED-MEDIA' &&
          (next.querySelector('video') || next.querySelector('template')?.content.querySelector('video'))) {
          next.classList.add('df-fit-video');
          if (!next.hasAttribute('loaded')) next.loadContent(false);
          const video = next.querySelector('video');
          if (video) {
            this.setupVideo(video);
            const withSound = userInitiated && navigator.userActivation?.isActive;
            if (withSound) {
              this.fitAudioVideos ||= new WeakSet();
              if (!this.fitAudioVideos.has(video)) {
                video.volume = 0.5;
                this.fitAudioVideos.add(video);
              }
            }
            video.muted = !withSound;
            video.controls = false;
            video.playsInline = true;
            if (video.ended) video.currentTime = 0;
            video.play()?.catch(() => {});
          }
        }
        this.updateFitArrows();
      }

      changeFitImage(step, userInitiated = false) {
        if (!this.classList.contains('df-fit-viewer')) return;
        const items = this.getFitMedia();
        const index = items.findIndex((item) => item.classList.contains('active'));
        if (index < 0 || items.length < 2) return;
        this.activateFitMedia(items[(index + step + items.length) % items.length], userInitiated);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        if (this.classList.contains('df-fit-viewer')) {
          this.activateFitMedia(activeMedia, Boolean(navigator.userActivation?.isActive));
          const container = this.querySelector('[role="document"]');
          container.scrollTop = 0;
          container.scrollLeft = 0;
          if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) activeMedia.loadContent();
          return;
        }
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
